import { useEventListener as o } from "./design-system.es125.js";
function s() {
  o(document.body, "mousedown", () => {
    document.body.classList.add("using-mouse");
  }), o(document.body, "keydown", () => {
    document.body.classList.remove("using-mouse");
  });
}
export {
  s as default
};
//# sourceMappingURL=design-system.es24.js.map
